import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { RefreshCw, WifiOff } from 'lucide-react'

const NetworkErrorPage: React.FC = () => {
  const navigate = useNavigate()

  const lastKnownPath = localStorage.getItem('lastPath') || '/';

  const handleReload = () => {
    navigate(lastKnownPath)
    localStorage.removeItem('lastPath');
  }

  useEffect(() => {
    // Clear the last path when the component mounts
    return () => {
      localStorage.removeItem('lastPath');
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl ">
        <div className="text-center">
          <WifiOff className="mx-auto h-16 w-16 text-gray-400" />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Network Error</h2>
          <p className="mt-2 text-sm text-gray-600">
            We're having trouble connecting to our servers. This could be due to a network issue or server maintenance.
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <button
            onClick={handleReload}
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Reload
          </button>
          <p className="text-center text-sm text-gray-500">
            If the problem persists, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  )
}

export default NetworkErrorPage